
<template>
  <transition name="fade">
    <div
      :class="{
        'f-modal': true,
        'is-big': isBig
      }">
      <div
        class="f-modal-dialog"
        role="document">
        <div class="f-modal-content card">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

export default {
  name: 'f-modal',
  props: {
    isBig: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.fade-enter {
  transform: translate(0,0);
  opacity: 1;
}
.fade-leave-active {
  transform: translate(0,0);
  opacity: 1;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.fade-enter .modal-dialog,
.fade-leave-active .modal-dialog {
  -webkit-transform: translate(0,-25%);
  transform: translate(0,-25%);
}
</style>
